import { cloneDeep } from 'lodash';

export default {
    initiateUndoRedo(event, collateralBuild) {
        if (this.canUndo(collateralBuild.versioning.keys, collateralBuild.versioning.currentIndex)) {
            event.preventDefault();
            this.undo(collateralBuild);
        }
        else if (this.canRedo(collateralBuild.versioning.keys, collateralBuild.versioning.currentIndex, collateralBuild.versioning.configurations.length - 1)) {
            event.preventDefault();
            this.redo(collateralBuild);
        }
    },

    addConfigurationToVersioning(collateralBuild) {
        if (!collateralBuild.versioning.updating) {
            this.syncVersioningConfigurations(collateralBuild);

            var underLimit = collateralBuild.versioning.configurations.length < collateralBuild.versioning.limit;
            if (underLimit) {
                collateralBuild.versioning.configurations.push(cloneDeep(collateralBuild.configuration));
                collateralBuild.versioning.currentIndex = collateralBuild.versioning.configurations.length - 1;
            }
            else {
                collateralBuild.versioning.configurations.shift();
                collateralBuild.versioning.configurations.push(cloneDeep(collateralBuild.configuration));
            }
        }
        else {
            collateralBuild.versioning.updating = false;
        }
    },

    syncVersioningConfigurations(collateralBuild) {
        var isCurrentIndexBehind = collateralBuild.versioning.currentIndex < collateralBuild.versioning.configurations.length - 1;

        if (isCurrentIndexBehind) {
            collateralBuild.versioning.configurations = collateralBuild.versioning.configurations.slice(0, collateralBuild.versioning.currentIndex + 1);
        }
    },

    canUndo(keys, currentIndex) {
        var controlActive = false;
        var macControlActive = false;
        var shiftActive = false;
        var zActive = false;

        keys.forEach(key => {
            if (key.name === 'control') {
                controlActive = key.active;
            }
            else if (key.name === 'macControl') {
                macControlActive = key.active;
            }
            else if (key.name === 'shift') {
                shiftActive = key.active;
            }
            else if (key.name === 'z') {
                zActive = key.active;
            }
        });

        return (controlActive || macControlActive)
            && zActive
            && !shiftActive
            && currentIndex > 0;
    },

    canRedo(keys, currentIndex, lastIndex) {
        var controlActive = false;
        var macControlActive = false;
        var shiftActive = false;
        var zActive = false;

        keys.forEach(key => {
            if (key.name === 'control') {
                controlActive = key.active;
            }
            else if (key.name === 'macControl') {
                macControlActive = key.active;
            }
            else if (key.name === 'shift') {
                shiftActive = key.active;
            }
            else if (key.name === 'z') {
                zActive = key.active;
            }
        });

        return (controlActive || macControlActive)
            && zActive
            && shiftActive
            && currentIndex < lastIndex;
    },

    undo(collateralBuild) {
        collateralBuild.configuration = cloneDeep(collateralBuild.versioning.configurations[collateralBuild.versioning.currentIndex - 1]);

        collateralBuild.versioning.currentIndex--;
        collateralBuild.versioning.updating = true;
    },

    redo(collateralBuild) {
        collateralBuild.configuration = cloneDeep(collateralBuild.versioning.configurations[collateralBuild.versioning.currentIndex + 1]);

        collateralBuild.versioning.currentIndex++;
        collateralBuild.versioning.updating = true;
    }
}